import { motion } from "framer-motion";
import { ArrowRight, MousePointer, Palette, Layout, Layers } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const UXUIHero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
      {/* Animated background elements */}
      <div className="absolute inset-0">
        {[MousePointer, Palette, Layout, Layers].map((Icon, index) => (
          <motion.div
            key={index}
            className="absolute text-blue-200/20"
            initial={{ 
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              scale: 0.5,
              opacity: 0.3
            }}
            animate={{
              x: Math.random() * window.innerWidth,
              y: Math.random() * window.innerHeight,
              scale: [0.5, 0.8, 0.5],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: 10 + Math.random() * 5,
              repeat: Infinity,
              ease: "linear"
            }}
          >
            <Icon size={100} />
          </motion.div>
        ))}
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white space-y-8"
        >
          <h1 className="text-5xl font-bold leading-tight">
            Crafting Digital
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-200 to-blue-400">
              {" "}Experiences{" "}
            </span>
            That Inspire
          </h1>
          <p className="text-xl text-blue-100 leading-relaxed">
            Transform your digital presence with our expert UX/UI design services. 
            We create intuitive, beautiful, and user-centered designs that drive engagement and results.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                Start Your Project
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Link to="/case-studies">
              <Button 
                size="lg" 
                variant="outline" 
                className="border-2 border-white text-white bg-white/10 hover:bg-white/20"
              >
                View Our Work
              </Button>
            </Link>
          </div>
        </motion.div>

        {/* Interactive Design Preview */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="relative bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: "Projects Completed", value: "15+" },
                { label: "Client Satisfaction", value: "100%" },
                { label: "Happy Clients", value: "10+" },
                { label: "Industries Served", value: "5+" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  className="p-4 rounded-xl bg-white/5 backdrop-blur-lg border border-white/10 text-center"
                >
                  <div className="text-3xl font-bold text-blue-200 mb-2">{stat.value}</div>
                  <div className="text-sm text-blue-100">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};